'use client';

import { useCallback, useContext, useMemo, useState } from 'react';

import ToastMessage from '../app/components/ToastMessage/ToastMessage';
import { ToastContext } from './toastContextValue';

// Реекспорт заради обратна съвместимост — самият контекст живее в `toastContextValue.js`,
// за да могат консуматорите да го вземат без да теглят провайдъра (виж коментара там).
export { ToastContext };

export const ToastProvider = ({ children }) => {
  const [toastMessage, setToastMessage] = useState({
    title: '',
    msg: '',
    variant: '',
    severity: '',
    maxAlerts: '',
    icon: false,
    position: 'bottomRight',
  });

  // Wrap setToastMessage в useCallback за да избегнем пересъздаване
  const handleSetToastMessage = useCallback((value) => {
    setToastMessage(value);
  }, []);

  const toastContext = useMemo(
    () => ({
      system_messages: {
        state: { ...toastMessage },
        set: handleSetToastMessage,
      },
    }),
    [toastMessage, handleSetToastMessage],
  );

  const value = useMemo(() => {
    return {
      toastContext,
    };
  }, [toastContext]);

  return (
    <ToastContext.Provider value={value}>
      {children}
      <ToastMessage
        title={toastMessage.title}
        message={toastMessage.msg ? toastMessage : null}
        variant={toastMessage.variant}
        severity={toastMessage.severity}
        maxSnack={toastMessage.maxAlerts}
        xIcon={toastMessage.xIcon}
        position={toastMessage.position}
      />
    </ToastContext.Provider>
  );
};

export const useToastContext = () => useContext(ToastContext);
